import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    dialog: {
      maxWidth: "90vw",
      maxHeight: "90vh",
      minHeight: "70vh",
      width: "100%",
      [theme.breakpoints.up("lg")]: {
        maxWidth: 1200,
      },
      [theme.breakpoints.down("sm")]: {
        maxWidth: "98vw",
      },
    },
    tablePaper: {
      boxShadow: "none",
    },
  })
);
